import React from 'react'
import { Tooltip, type IIconsVector } from 'shared/ui'
import { BoxIcon } from 'shared/ui/Icon/BoxIcon'
import { type ITriggerType } from 'entities/Trigger/api/type'

const config: Record<ITriggerType, { icon: IIconsVector; label: string }> = {
  sms: {
    icon: 'messageSmile' as IIconsVector,
    label: 'SMS',
  },
  ringless: {
    icon: 'voicemail2' as IIconsVector,
    label: 'Ringless',
  },
  rcs: {
    icon: 'rcs' as IIconsVector,
    label: 'RCS',
  },
}

export const TriggerType = ({ type }: { type: ITriggerType }) => (
  <Tooltip label={config[type]?.label} placement={'top'}>
    <BoxIcon icon={config[type]?.icon} tertiary />
  </Tooltip>
)
